import React from 'react';
import H5FeedbackFilterContent from './FilterContent';
import type { FeedbackFilterOption, FeedbackFilterParams } from '../index';
import type { FeedbackProductCategory, FeedbackProductItem, FetchProductsParams } from '@components/feedbackProductPicker';
import type { FeedbackProblemCategory, FeedbackProblemItem } from '@components/feedbackProblemPicker';

interface H5FeedbackFilterProps {
    filterParams: FeedbackFilterParams;
    searchInputValue: string;
    solveStateList: FeedbackFilterOption[];
    problemList: FeedbackFilterOption[];
    problemCategories: FeedbackProblemCategory[];
    productList: FeedbackFilterOption[];
    productCategories: FeedbackProductCategory[];
    daysList: FeedbackFilterOption[];
    onSearchChange?: (value: string) => void;
    onSearchConfirm?: () => void;
    onFilterChange?: (key: keyof FeedbackFilterParams, value: string) => void;
    onAdvancedFilterConfirm?: (values: Pick<FeedbackFilterParams, 'solveState' | 'daysValue'>) => void;
    onProblemSelect?: (problem: FeedbackProblemItem | null) => void;
    onProductSelect?: (product: FeedbackProductItem | null) => void;
    fetchProducts?: (params: FetchProductsParams) => Promise<FeedbackProductItem[]>;
    showSearchBar?: boolean;
    onSearchBack?: () => void;
}

/** H5 筛选入口，渲染 H5FeedbackFilterContent */
class H5FeedbackFilter extends React.Component<H5FeedbackFilterProps> {
    render() {
        return <H5FeedbackFilterContent {...this.props} />;
    }
}

export default H5FeedbackFilter;
